import { decode as base64_decode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable } from "mobx";

class AssignVehicleToUserStore {
  total = 0;
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      addData: action,
    });
    this.rootStore = rootStore;
  }

  async addData(postData) {
    var vehicleData = { postData };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("users/userAssignVehicle", vehicleData);

    return response;
  }

  async getAllUserVehicleFunc({ companyId, userId }) {
    var postData = {
      ruleId: "",
      addedByUserId: "",
      companyId: companyId,
      userId: userId,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("users/getAllUserVehicles", { params: postData });

    return response.data;
  }
}

export default AssignVehicleToUserStore;
